export default __webpack_public_path__ + "static/media/active-doctor-home.325ff98d.svg";